import BaseService from "./BaseService";
import AppConfiguration from "dataProvider/config";

export default class AdminService extends BaseService {
  constructor() {
    super(AppConfiguration.apiBaseMap, "admcsm");
  }

  async getAllMenu() {
    const path = "/api/v2/menu/all";
    const configs = this.getConfigs({});
    return await this.doGet(path, configs);
  }
  async getUsers(params) {
    params.page = params.page - 1;
    const path = "/api/v2/user/search";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getUserDetail(params) {
    const path = "/api/v2/user";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }

  async addUser(data, params) {
    const path = "/api/v2/user";
    const configs = this.getConfigs({
      params
    });
    return await this.doPost(path, data, configs);
  }
  async editUser(data, params) {
    const path = "/api/v2/user";
    const configs = this.getConfigs({
      params
    });
    return await this.doPut(path, data, configs);
  }
  async deleteUser(params) {
    const path = "/api/v2/user";
    const configs = this.getConfigs({
      params
    });
    return await this.doDelete(path, configs);
  }

  async getGroups(params) {
    params.page = params.page - 1;
    const path = "/api/v2/group/search";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async getGroupDetail(params) {
    const path = "/api/v2/group";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }
  async addGroup(data, params) {
    const path = "/api/v2/group";
    const configs = this.getConfigs({
      params
    });
    return await this.doPost(path, data, configs);
  }

  async editGroup(data, params) {
    const path = "/api/v2/group";
    const configs = this.getConfigs({
      params
    });
    return await this.doPut(path, data, configs);
  }
  async deleteGroup(params) {
    const path = "/api/v2/group";
    const configs = this.getConfigs({
      params
    });
    return await this.doDelete(path, configs);
  }
  async addUserIntoGroup(data, params) {
    const path = "/api/v2/group/add-remove";
    const configs = this.getConfigs({
      params
    });
    return await this.doPost(path, data, configs);
  }

  async addComponent(data, params) {
    const path = "/component";
    const configs = this.getConfigs({
      params
    });
    return await this.doPost(path, data, configs);
  }
  async editComponent(data, params) {
    const path = "/component";
    const configs = this.getConfigs({
      params
    });
    return await this.doPut(path, data, configs);
  }
  async getComponents(params) {
    const path = "/component";
    const configs = this.getConfigs({
      params
    });
    return await this.doGet(path, configs);
  }

  enableUserTOTP(data) {
    const path = "api/v1/totp/enable";
    return this.doPut(path, data);
  }

  revokeUserTOTP(data) {
    const path = "api/v1/totp/revoke";
    return this.doPut(path, data);
  }

  getQrCode() {
    const path = "api/v1/totp/get-secret";
    return this.doGet(path);
  }
}
